import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { tree } from "@/api/system/menu";
import { auth, getRoleAuth } from "@/api/system/role";
import { Dialog } from "@/component-create/Dialog";
import { MENU_STATUS, MENU_STYLE } from "@/constant/system/code";
import { toast } from "@/utils/message";
import { ElInput, ElTree, ElTag, ElButton, ElLoading } from 'element-plus';
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/tree/style/css'
import 'element-plus/es/components/tag/style/css'
import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/loading/style/css'

var dialog = null;
export function renderAuthDialog(el) {
  dialog = new Dialog(el, AuthTree, '授权', '40%', [{
    el: function el(_el) {
      return h(_createVNode("div", null, [_createVNode(ElButton, {
        "onClick": function onClick() {
          var _dialog;
          (_dialog = dialog) === null || _dialog === void 0 || _dialog.close();
        }
      }, {
        default: function _default() {
          return [_createTextVNode("\u53D6\u6D88")];
        }
      }), _createVNode(ElButton, {
        "type": "primary",
        "onClick": function onClick() {
          submit(_el);
        }
      }, {
        default: function _default() {
          return [_createTextVNode("\u6388\u6743")];
        }
      })]));
    }
  }]);
  return dialog;
}
var AuthTree = defineComponent({
  props: {
    roleId: [String, Number]
  },
  setup: function setup(prop, _ref) {
    var expose = _ref.expose;
    var data = ref();
    var filter = ref('');
    var treeRef = ref();
    // 选中操作
    var grantedAction = ref([]);
    // 选中菜单
    var grantedMenu = ref([]);
    var loading = null;
    // 获取树形数据
    tree({
      action: true
    }).then(function (result) {
      data.value = setupMenusKey(result.data);
      console.log(data.value);
    });
    watch(function () {
      return prop.roleId;
    }, function (newVal) {
      if (newVal) {
        filter.value = '';
        // 获取选中节点
        getRoleAuth(newVal).then(function (res) {
          if (treeRef.value) {
            grantedAction.value = res.data.grantedAction.map(function (item) {
              return item.id + MENU_STYLE.ACTION;
            });
            grantedMenu.value = res.data.grantedMenu.map(function (item) {
              return item.id + MENU_STYLE.MENU;
            });
            treeRef.value.setCheckedKeys([].concat(_toConsumableArray(grantedAction.value), _toConsumableArray(grantedMenu.value)));
          }
        });
      }
    }, {
      immediate: true
    });
    watch(filter, function (val) {
      treeRef.value.filter(val);
    });
    onMounted(function () {
      // 初始化选中节点
      if (treeRef.value) {
        treeRef.value.setCheckedKeys([].concat(_toConsumableArray(grantedAction.value), _toConsumableArray(grantedMenu.value)));
      }
    });
    function filterAuthTree(value, data) {
      if (!value) return true;
      return data.menuName.indexOf(value) !== -1;
    }
    // 获取选中数据
    function getCheckedKeys() {
      if (treeRef.value) {
        return treeRef.value.getCheckedKeys();
      }
      return [];
    }
    function getRoleId() {
      return prop.roleId;
    }
    function loadingStart() {
      loading = ElLoading.service({
        target: treeRef.value.$el
      });
    }
    function loadingEnd() {
      loading.close();
    }
    expose({
      getCheckedKeys: getCheckedKeys,
      getRoleId: getRoleId,
      loadingStart: loadingStart,
      loadingEnd: loadingEnd
    });
    // 自定义节点内容
    var renderContent = function renderContent(h, _ref2) {
      var node = _ref2.node,
        data = _ref2.data;
      return h(_createVNode("span", {
        "style": {
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '14px',
          paddingRight: '8px'
        }
      }, [data.status === MENU_STATUS.DISABLED.CODE ? _createVNode("span", {
        "style": {
          color: 'darkgray'
        }
      }, [node.label]) : _createVNode("span", null, [node.label]), _createVNode("span", {
        "class": "custom-tree-node-tag"
      }, [data.status === MENU_STATUS.DISABLED.CODE ? _createVNode(ElTag, {
        "type": "danger",
        "size": "small",
        "style": "margin-right: 10px"
      }, {
        default: function _default() {
          return [_createTextVNode("\u5DF2\u505C\u7528")];
        }
      }) : _createVNode("span", null, null), data.menuStyle === MENU_STYLE.CATALOG ? _createVNode(ElTag, {
        "size": "small"
      }, {
        default: function _default() {
          return [_createTextVNode("\u76EE\u5F55")];
        }
      }) : data.menuStyle === MENU_STYLE.MENU ? _createVNode(ElTag, {
        "type": "success",
        "size": "small"
      }, {
        default: function _default() {
          return [_createTextVNode("\u83DC\u5355")];
        }
      }) : _createVNode(ElTag, {
        "type": "info",
        "size": "small"
      }, {
        default: function _default() {
          return [_createTextVNode("\u64CD\u4F5C")];
        }
      })])]));
    };
    return function () {
      return _createVNode("div", null, [_createVNode(ElInput, {
        "modelValue": filter.value,
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return filter.value = $event;
        },
        "placeholder": "\u8F93\u5165\u5173\u952E\u8BCD\u8FDB\u884C\u8FC7\u6EE4"
      }, null), _createVNode(ElTree, {
        "check-strictly": true,
        "ref": treeRef,
        "data": data.value,
        "props": {
          label: 'menuName'
        },
        "node-key": "key",
        "show-checkbox": true,
        "highlight-current": true,
        "style": "margin-top: 10px",
        "render-content": renderContent,
        "expand-on-click-node": true,
        "filter-node-method": filterAuthTree
      }, null)]);
    };
  }
});
// 提交
function submit(el) {
  console.log(el.value);
  var keys = el.value.getCheckedKeys();
  var resultAction = keys.filter(function (id) {
    return id.includes(MENU_STYLE.ACTION);
  }).map(function (id) {
    return {
      id: Number(id.replace(MENU_STYLE.ACTION, ''))
    };
  });
  var resultMenu = keys.filter(function (id) {
    return id.includes(MENU_STYLE.MENU);
  }).map(function (id) {
    return {
      id: Number(id.replace(MENU_STYLE.MENU, ''))
    };
  });
  el.value.loadingStart();
  auth({
    roleId: el.value.getRoleId(),
    grantedMenu: resultMenu,
    grantedAction: resultAction
  }).then(function () {
    toast.success('授权成功');
    if (dialog) {
      dialog.close();
    }
  }).finally(function () {
    el.value.loadingEnd();
  });
}
// 构造key
function setupMenusKey(menus) {
  var result = [];
  if (!menus || menus.length < 1) {
    return result;
  }
  var _iterator = _createForOfIteratorHelper(menus),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var menu = _step.value;
      if (menu.children && menu.children.length > 0) {
        menu.children = setupMenusKey(menu.children);
      }
      menu.key = menu.menuStyle === MENU_STYLE.CATALOG ? menu.id + MENU_STYLE.MENU : menu.id + menu.menuStyle;
      result.push(menu);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
}